export default {"src":"/_next/static/media/0xB8647e90C0645152Fccf4d9AbB6B59Eb4AA99052.391f9b88.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};